class CartRecommendationsComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Shopify's recommendations endpoint returns at most 10 products.
    const MAX_FETCH_LIMIT = 10;

    const url = new URL(this.dataset.url, window.location.origin);

    // The number of cards the store wants to show (the original `limit` in data-url).
    // If none was set, Shopify's default of 10 is used and no trimming is needed.
    const displayLimit = parseInt(url.searchParams.get("limit"), 10) || null;

    // Fetch extra products so there's a buffer after excluded products are filtered out in Liquid.
    url.searchParams.set("limit", MAX_FETCH_LIMIT);

    fetch(url.toString())
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          "#shopify-section-cart-recommendations"
        );
        if (!recommendations) return;

        const items = recommendations.querySelectorAll(
          ".f-cart-recommendations__item"
        );
        if (!items.length) return;

        // Trim back down to the originally requested number of cards
        // before the slider is inserted and initialized.
        if (displayLimit && items.length > displayLimit) {
          Array.from(items)
            .slice(displayLimit)
            .forEach((item) => item.remove());

          if (displayLimit === 1) {
            const container = recommendations.querySelector(
              ".f-cart-recommendations__items"
            );
            if (container) {
              container.classList.add(
                "f-cart-recommendations__items-only-product"
              );
            }
          }
        }

        this.innerHTML = recommendations.innerHTML;
      })
      .catch((err) => console.error(err));
  }
}

customElements.define(
  "cart-recommendations-component",
  CartRecommendationsComponent
);

if (!customElements.get("add-to-cart-component")) {
  class AddToCartComponent extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = document.querySelector("cart-drawer");
      this.addToCartButton = this.querySelector(
        ".f-cart-recommendations__item-add-to-cart"
      );
      this.addEventListener("click", this.onSubmitHandler.bind(this));
    }

    onSubmitHandler() {
      this.addToCartButton.classList.add("btn--loading");
      const variantId = this.dataset.variantId;

      if (!variantId) return;

      const config = {
        method: "POST",
        headers: {
          Accept: "application/javascript",
          "X-Requested-With": "XMLHttpRequest",
        },
      };

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", 1);

      if (this.cartDrawer) {
        formData.append(
          "sections",
          this.cartDrawer.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
      }

      config.body = formData;

      fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return this.Notification.show({
              target: document.body,
              method: "appendChild",
              type: "warning",
              message: response.description,
              last: 3000,
              sticky: true,
            });
          }
          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.addToCartButton.classList.remove("btn--loading");
        });
    }
  }
  customElements.define("add-to-cart-button", AddToCartComponent);
}
